import { render, staticRenderFns } from "./platformCrawlStatus.vue?vue&type=template&id=54186056&scoped=true"
import script from "./platformCrawlStatus.vue?vue&type=script&lang=ts"
export * from "./platformCrawlStatus.vue?vue&type=script&lang=ts"
import style0 from "./platformCrawlStatus.vue?vue&type=style&index=0&id=54186056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54186056",
  null
  
)

export default component.exports